var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamConnectIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.43 6.93C18.6058 5.71878 17.498 4.72748 16.2029 4.04249C14.9079 3.3575 13.465 2.99961 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21C15.09 21 17.81 19.44 19.43 17.07",
    fill: "#F37D53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5L19 9L19.5 15L20.5 11.5Z",
    fill: "#F37D53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9199 14.4098L20.7299 12.9998C21.0899 12.3798 21.0899 11.6198 20.7299 10.9998L19.9199 9.58984",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12L17 12",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9199 14.4098L20.7299 12.9998C21.0899 12.3798 21.0899 11.6198 20.7299 10.9998L19.9199 9.58984",
    stroke: "#F37D53",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8101 12H16.8201",
    stroke: "#F37D53",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1027 8.38733C14.2699 7.66194 13.1869 7.2207 11.99 7.2207C10.7222 7.2207 9.50641 7.72431 8.60999 8.62073C7.71357 9.51716 7.20996 10.733 7.20996 12.0007C7.20996 13.2684 7.71357 14.4843 8.60999 15.3807C9.50641 16.2771 10.7222 16.7807 11.99 16.7807C13.1281 16.7807 14.1711 16.377 14.9905 15.7071",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamConnectIconActive);
export default __webpack_public_path__ + "static/media/team_connect_icon_active.c414cd8228a38279b6cf8228a0e96c1e.svg";
export { ForwardRef as ReactComponent };